import { useRouter } from "next/router";

export default function HtmlContent({ content }) {
  const router = useRouter();

  const handleAnchorClick = (e) => {
    // e.preventDefault();
    //
    // console.log(e);
    //
    // const targetLink = e.target.closest('a');
    // if (!targetLink) return;
    // e.preventDefault();
    //
    // // const redirectThis = fixLink(targetLink.href);
    // const redirectThis = targetLink.href;
    //
    // console.log(redirectThis);
    //
    // // router.push(`/${redirectThis}`);
  };

  return (
    <div
      onClick={handleAnchorClick}
      onKeyPress={handleAnchorClick}
      className="content"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
